export default "__VITE_ASSET__CvLMx85Z__"